import * as React from 'react'

import { Box, type Colors, Icon, Text, Touchable } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface EditionWindowProps {
  label: string
  value: string
  second?: string
  selected: boolean | undefined
  icon: React.ComponentProps<typeof Icon.Medium>['icon']
  complete?: boolean
  placeholder?: string
  focusColor?: Colors
  onChange: (label: string) => void
}

export const EditionWindow = ({
  label,
  value,
  second,
  selected = false,
  icon,
  complete = true,
  placeholder = i18n.t('performance_process.reviews.secondary_title_placeholder'),
  focusColor = 'grey200',
  onChange,
}: React.PropsWithChildren<EditionWindowProps>) => {
  return (
    <Box width="s300">
      <Touchable onClick={() => onChange(value)} buttonBorderRadius="abs016" expand={false}>
        <Box
          width="full"
          flexDirection="row"
          justifyContent="spaceBetween"
          padding="s12"
          alignItems="center"
          background={selected ? focusColor : 'grey000White'}
          borderRadius={{ all: 'abs016' }}
        >
          <Box flexDirection="row" gap="s8" alignItems="flexStart" textAlign="left">
            <Icon.Medium icon={icon} color="grey800" />
            <Box maxWidth="s200">
              <Text.Normal size="300" weight="semibold" color="grey1000" ellipsis>
                {label}
              </Text.Normal>

              <Text.Normal size="200" ellipsis color={second ? 'grey1000' : 'grey600'}>
                {second || (!complete && placeholder)}
              </Text.Normal>
            </Box>
          </Box>
          <Icon.Medium icon="chevron-right" color={selected ? 'grey800' : 'grey000White'} />
        </Box>
      </Touchable>
    </Box>
  )
}
